module.exports = __webpack_public_path__ + "img/pr-9.4712abda.png";